module.exports = __webpack_public_path__ + "static/media/2000_GDP_totalRate.2458a3de.png";